import React, { memo, useContext } from "react";
import { ChatContext } from "context/Context";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowMinimize } from "@fortawesome/free-solid-svg-icons";

const WindowHeader = () => {
    const { setChatWindowOpen } = useContext(ChatContext);
    return (
        <div>
            <Button
                variant="outline-secondary"
                className="float-end border-0 me-3"
                size="sm"
                id="btnMinimiseChat"
                title="Minimise"
                onClick={() => setChatWindowOpen(prev => !prev)}
            ><FontAwesomeIcon icon={faWindowMinimize} />
            </Button>
        </div>
    );
}

export default memo(WindowHeader);